import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
`

export const InfoContainer = styled.div`
  display: flex;
  min-width: 640px;
  width: 720px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px 12px;
  margin-bottom: 15px;
`

export const RegisterColumn = styled(Container)`
  width: 50%;
  height: 100%;
  padding: 10px 0px 12px;
  align-items: flex-start;

  &:first-child {
    padding-right: 0px;
  }
`

export const Info = styled(InfoContainer)`
  margin: 0px;
  padding: 0px !important;
  border: 0px;
  box-shadow: none;
  width: 100%;
  height: auto;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const InfoRow = styled(Row)`
  justify-content: space-between;
`

export const InfoLink = styled.button`
  display: flex;
  align-items: center;
  border: 0px;
  padding: 0px;
  width: 100%;
  justify-content: space-between;
  background-color: transparent;

  &:hover, &:active {
    border: 0px;
  }

  &:hover p {
    color: #35A7FF
  };
`

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  margin: 5px 0px 3px;
  background-color: #E0E0E0;
`

export const VerticalLine = styled.div`
  width: 1px;
  background-color: #E0E0E0;
  align-self: stretch;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`
